import { render } from "./blue-free-shipment-info.vue?vue&type=template&id=3a5e8a92&ts=true"
import script from "./blue-free-shipment-info.vue?vue&type=script&lang=ts"
export * from "./blue-free-shipment-info.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__